<template>
  <div class="panel mt-20">
    <el-form
      label-position="left"
      ref="setForm"
      :model="setForm"
      label-width="90px"
    >
      <el-form-item label="坐席人数">
        <el-input-number
          v-model="setForm.seats"
          :min="1"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="登录方式">
        <el-checkbox-group v-model="setForm.entrances">
          <el-checkbox
            v-for="(v, k) in LoginEntrances"
            :key="k"
            :label="parseInt(k)"
            >{{ v }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="">
        <el-button
          size="small"
          :disabled="submiting"
          type="primary"
          @click="submit"
          >确认提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { LoginEntrances } from '../../config/global'
import { updateDealerUsage } from '../../service/getData'

export default {
  props: {
    usage: {},
  },
  data() {
    return {
      LoginEntrances,
      submiting: false,
      setForm: {
        seats: 0,
        entrances: [],
        dealer_id: 0,
      },
    }
  },
  created() {
    if (this.usage) {
      this.setForm = this.usage
    }
  },
  methods: {
    async submit() {
      this.submiting = true
      let res = await updateDealerUsage(this.setForm)
      if (res.code == 0) {
        this.$message.success('设置成功')
      }
      this.submiting = false
    },
  },
}
</script>